import React, { useEffect, useRef, useState } from "react";

const stats = [
  { value: 500, suffix: "+", label: "Business Clients" },
  { value: 10, suffix: "+", label: "Product Variants" },
  { value: 20, suffix: "+", label: "Distribution Partners" },
  { value: 100, suffix: "%", label: "Food Safe Products" },
];

const useCount = (target, active) => {
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const dur = 1400;
    const startTime = performance.now();
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - startTime) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setV(Math.floor(eased * target));
      if (p < 1) raf = requestAnimationFrame(step);
      else setV(target);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [active, target]);
  return v;
};

const StatItem = ({ s, active }) => {
  const v = useCount(s.value, active);
  return (
    <div className="text-center">
      <div className="font-display text-5xl md:text-7xl font-extrabold tracking-tight">
        <span className="vc-text-gradient">{v}{s.suffix}</span>
      </div>
      <div className="mt-3 text-neutral-400 text-sm md:text-base font-medium">
        {s.label}
      </div>
    </div>
  );
};

export const Statistics = () => {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setActive(true); },
      { threshold: 0.3 }
    );
    const node = ref.current;
    if (node) obs.observe(node);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      data-testid="statistics-section"
      className="relative py-24 md:py-28 bg-[#0A0A0A] text-white overflow-hidden"
    >
      <div className="absolute inset-0 vc-noise opacity-30" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full vc-gradient opacity-20 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="font-mono-vc text-xs uppercase tracking-[0.25em] vc-text-gradient font-bold">
            By the Numbers
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold">
            Trusted scale. Proven reliability.
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10">
          {stats.map((s) => (
            <StatItem key={s.label} s={s} active={active} />
          ))}
        </div>
      </div>
    </section>
  );
};
